export default __webpack_public_path__ + "static/media/clipboard.c41ecd6f.webp";